<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div
          v-if="role !== 2"
          class="md-layout-item md-size-100 md-small-size-100"
        >
          <ValidationProvider
            name="title"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Title</label>
              <md-input v-model="title" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider
            name="gender"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Gender</label>
              <md-select v-model="gender" name="gender">
                <md-option value="">Select Gender</md-option>
                <md-option value="M">Male</md-option>
                <md-option value="F">Female</md-option>
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider
            name="mobile_phone"
            rules="required|numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Mobile Phone</label>
              <md-input v-model="mobile_phone" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider
            name="country"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Country</label>
              <md-select v-model="country" name="country">
                <md-option value="">Select Country</md-option>
                <md-option
                  v-for="c in countries"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div
          v-if="$store.role === 1 && role === 4"
          class="md-layout-item md-size-100 md-small-size-100"
        >
          <ValidationProvider
            name="university"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>University</label>
              <md-select v-model="university" name="university">
                <md-option value="">Select University</md-option>
                <md-option
                  v-for="c in universities"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div
          v-if="
            ($store.role === 1 && role === 3) ||
              ($store.role === 3 && role === 3)
          "
          class="md-layout-item md-size-100 md-small-size-100"
        >
          <ValidationProvider
            name="agency"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Agency</label>
              <md-select v-model="agency" name="agency">
                <md-option value="">Select Agency</md-option>
                <md-option
                  v-for="c in agencies"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div
          v-if="$store.role === 1 && role === 5"
          class="md-layout-item md-size-100 md-small-size-100"
        >
          <ValidationProvider
            name="dorm"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Dorm</label>
              <md-select v-model="dorm" name="dorm">
                <md-option value="">Select Dorm</md-option>
                <md-option v-for="c in dorms" v-bind:key="c.id" :value="c.id">{{
                  c.name
                }}</md-option>
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div
          v-if="$route.meta.update === true"
          class="md-layout-item md-size-33 md-small-size-100"
        >
          <md-checkbox v-model="is_active">Is active?</md-checkbox>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      role: null,
      title: null,
      gender: null,
      mobile_phone: null,
      country: "",
      is_active: false,
      countries: null,
      universities: [],
      agencies: [],
      dorms: [],
      university: null,
      agency: null,
      dorm: null
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }
        this.$emit("on-validated", res);
        return res;
      });
    }
  },
  mounted() {
    this.$route.meta.update;
    this.$store
      .getCountries()
      .then(response => {
        this.countries = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
    if (this.$route.meta.staff === "university") {
      this.role = 4;
      this.$store
        .getUniversities()
        .then(response => {
          this.universities = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    } else if (this.$route.meta.staff === "agency") {
      this.role = 3;
      this.$store
        .getAgencies({"limit": 500})
        .then(response => {
          this.agencies = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    } else if (this.$route.meta.staff === "dorm") {
      this.role = 5;
      this.$store
        .getDorms()
        .then(response => {
          this.dorms = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    } else if (this.$route.meta.staff === "admin") {
      this.role = 1;
    } else {
      this.role = 2;
    }
  }
};
</script>
<style lang="scss" scoped>
  .color {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 16px;
    border: 1px solid rgba(#000, .12);
  }

  .md-helper-text {
    display: flex;
    align-items: center;

    .color {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }
  }
</style>
